export const USER_ROLES = ['ADMIN', 'STAFF', 'REGISTRATION'] as const;

export type UserRole = (typeof USER_ROLES)[number];

/** Route used when an authenticated user needs a safe landing page. */
export const FALLBACK_ROUTE = 'records' as const;

const ALL_ROLES: readonly UserRole[] = USER_ROLES;
const OPERATIONS_ROLES: readonly UserRole[] = ['ADMIN', 'STAFF'];
const ADMIN_ROLES: readonly UserRole[] = ['ADMIN'];

/**
 * Single source of truth for page-level access. The router and sidebar both use
 * this map so hiding a menu item can never be mistaken for route protection.
 */
export const ROUTE_ACCESS: Readonly<Record<string, readonly UserRole[]>> = {
  dashboard: OPERATIONS_ROLES,
  member: OPERATIONS_ROLES,
  rate: ADMIN_ROLES,
  courtesy: ADMIN_ROLES,
  'work-shift': OPERATIONS_ROLES,
  subscriptions: OPERATIONS_ROLES,
  'new-subscription': OPERATIONS_ROLES,
  [FALLBACK_ROUTE]: ALL_ROLES,
  inventory: ADMIN_ROLES,
  sales: OPERATIONS_ROLES,
  user: ADMIN_ROLES,
  configuration: ADMIN_ROLES,
  reports: ADMIN_ROLES,
  calendar: ADMIN_ROLES,
  'check-in-catalog': ADMIN_ROLES,
};

export function isUserRole(role: string | null): role is UserRole {
  return USER_ROLES.some(knownRole => knownRole === role);
}

export function canAccessRoute(route: string, role: string | null): boolean {
  if (!isUserRole(role)) return false;

  return ROUTE_ACCESS[route]?.includes(role) ?? false;
}
